if (typeof (window as any).globalThis === 'undefined') {
  Object.defineProperty(window, 'globalThis', {
    value: window,
    configurable: true,
    writable: true
  });
}

if (typeof (window as any).queueMicrotask === 'undefined') {
  Object.defineProperty(window, 'queueMicrotask', {
    value: function(callback: Function) {
      Promise.resolve()
        .then(function() {
          callback();
        })
        .catch(function(error) {
          setTimeout(function() {
            throw error;
          }, 0);
        });
    },
    configurable: true,
    writable: true
  });
}

if (typeof Array.prototype.flat === 'undefined') {
  Object.defineProperty(Array.prototype, 'flat', {
    value: function(depth?: number) {
      var result: any[] = [];
      var maxDepth = depth === undefined ? 1 : Number(depth) || 0;

      var flatten = function(items: any, currentDepth: number) {
        for (var index = 0; index < items.length; index += 1) {
          if (!(index in items)) {
            continue;
          }

          var item = items[index];
          if (Array.isArray(item) && currentDepth > 0) {
            flatten(item, currentDepth - 1);
          } else {
            result.push(item);
          }
        }
      };

      flatten(Object(this), maxDepth);
      return result;
    },
    configurable: true,
    writable: true
  });
}

if (typeof Array.prototype.flatMap === 'undefined') {
  Object.defineProperty(Array.prototype, 'flatMap', {
    value: function(callback: Function, thisArg?: any) {
      return Array.prototype.map.call(this, callback, thisArg).flat();
    },
    configurable: true,
    writable: true
  });
}

if (typeof String.prototype.replaceAll === 'undefined') {
  Object.defineProperty(String.prototype, 'replaceAll', {
    value: function(searchValue: string | RegExp, replaceValue: string) {
      if (searchValue instanceof RegExp) {
        return this.replace(searchValue, replaceValue);
      }

      return this.split(String(searchValue)).join(replaceValue);
    },
    configurable: true,
    writable: true
  });
}
